<template>
    <div class="ZyWithoutCodeLogin">
        <!-- <WithoutCodeLogin
            :UserNames="UserName"
            :PassWords="PassWord"
        ></WithoutCodeLogin> -->
        <van-empty image="error" description="链接已失效，请退出此页面" />
    </div>
</template>

<script>
// import WithoutCodeLogin from "../../components/openCard/WithoutCodeLoginPublic.vue"
export default {
    // components: { WithoutCodeLogin },
    data() {
        return {
            // // 郑州思维通讯产品有限公司
            // UserName: "HNZZZY001", //测试工号 SHSHZY003  正式：JSKSZNZY001
            // PassWord: "SiweI159#%", //测试密码  744810   正式密码：Kszn1234567@@123
        }
    },

    created() { },
    // 组件方法
    methods: {},

    computed: {},

    mounted() { },
}
</script>

<style scoped lang='scss'></style>